var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShowFile
        ? _c(
            "el-card",
            {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { header: "投保盖章文件" },
            },
            [
              _c("avue-form", {
                ref: "fileForm",
                attrs: {
                  option: _vm.optionFileConfirm,
                  "upload-before": _vm.onUploadBefore,
                },
                on: { submit: _vm.onSubmitFileConfirm },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "insureConfirmUrl",
                      fn: function (ref) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onDownLoadTemp },
                            },
                            [_vm._v("下载模板")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "menuForm",
                      fn: function (ref) {
                        return [
                          _vm.isSubmitted
                            ? _c(
                                "el-button",
                                {
                                  attrs: { icon: "el-icon-edit" },
                                  on: { click: _vm.onEditFileConfirm },
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  184287433
                ),
                model: {
                  value: _vm.formFileConfirm,
                  callback: function ($$v) {
                    _vm.formFileConfirm = $$v
                  },
                  expression: "formFileConfirm",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }